import { Injectable, NgZone, Inject, DOCUMENT } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';

// Angular 20+ a supprime le support natif de HammerJS (HammerModule, HammerGestureConfig,
// HAMMER_GESTURE_CONFIG). Ce plugin remplace l'ancien HammerModule + AuroraHammerConfig
// pour continuer a fournir les evenements de geste ((swipeup), (swipedown), etc.)
// avec le swipe autorise dans toutes les directions (DIRECTION_ALL).
const HAMMER_GESTURE_EVENTS = new Set([
    'drag', 'dragstart', 'dragend', 'dragleft', 'dragright', 'dragup', 'dragdown',
    'swipe', 'swipeleft', 'swiperight', 'swipeup', 'swipedown',
    'pan', 'panstart', 'panmove', 'panend', 'pancancel', 'panleft', 'panright', 'panup', 'pandown',
    'pinch', 'pinchstart', 'pinchmove', 'pinchend', 'pinchcancel', 'pinchin', 'pinchout',
    'press', 'pressup',
    'rotate', 'rotatestart', 'rotatemove', 'rotateend', 'rotatecancel',
    'tap', 'doubletap'
]);

@Injectable()
export class HammerGesturesPlugin extends EventManagerPlugin
{
    constructor (@Inject(DOCUMENT) doc: any, private ngZone: NgZone)
    {
        super(doc);
    }

    override supports (eventName: string): boolean
    {
        return HAMMER_GESTURE_EVENTS.has(eventName.toLowerCase());
    }

    override addEventListener (element: HTMLElement, eventName: string, handler: (event: HammerInput) => void): Function
    {
        const manager = this.getManager(element);

        manager.on(eventName, (event: HammerInput) =>
        {
            this.ngZone.run(() => handler(event));
        });

        return () => manager.off(eventName, handler);
    }

    private getManager (element: HTMLElement): HammerManager
    {
        let manager = (element as any).hammerManager as HammerManager;

        if (!manager)
        {
            this.ngZone.runOutsideAngular(() =>
            {
                manager = new Hammer.Manager(element);
                manager.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_ALL }));
                manager.add(new Hammer.Pan());
                manager.add(new Hammer.Tap());
                manager.add(new Hammer.Press());
                (element as any).hammerManager = manager;
            });
        }

        return manager;
    }
}